async function refreshFoxCartDrawer({ open = true } = {}) {
  const drawer = document.querySelector('cart-drawer#CartDrawer');
  if (!drawer) return;

  const sectionId = drawer.dataset.sectionId;
  const url = `${window.Shopify.routes.root}?sections=${encodeURIComponent(sectionId)}`;

  const res = await fetch(url);
  const data = await res.json();
  const markup = data[sectionId];
  if (!markup) return;

  const parsed = new DOMParser().parseFromString(markup, 'text/html');

  // Swap only the parts that change with cart contents, leave the header (and its
  // already-bound close button) in place.
  const idsToSwap = [
    `#CartDrawerEmpty-${sectionId}`,
    `#CartDrawerBody-${sectionId}`,
    `#CartDrawerFooter-${sectionId}`,
  ];

  idsToSwap.forEach((sel) => {
    const fresh = parsed.querySelector(sel);
    const current = drawer.querySelector(sel);
    if (fresh && current) current.replaceWith(fresh);
  });

  if (open) openFoxCartDrawer(drawer);
}

      function openFoxCartDrawer(drawer) {
        if (typeof drawer.open === 'function') return drawer.open();
        if (typeof drawer.show === 'function') return drawer.show();

        // Fallback: click the header cart trigger (aria-controls outside the drawer)
        const opener = [...document.querySelectorAll('[aria-controls="CartDrawer"]')].find(
          (el) => !el.closest('#CartDrawer')
        );
        opener?.click();
      }

      async function getCartCount() {
        try {
          const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
          return cart.item_count;
        } catch {
          return null;
        }
      }

      function updateHeaderCount(count) {
        if (count == null) return;
        const selector = 'cart-count, .cart-count, [data-cart-count]';
        document.querySelectorAll(selector).forEach((el) => {
          if (el.closest('#CartDrawer')) return; // drawer count is handled by the drawer re-render
          el.textContent = count;
          el.hidden = count === 0;
          const label = el.getAttribute('aria-label');
          if (label) el.setAttribute('aria-label', label.replace(/\d+/, count));
        });
      }

      document.addEventListener('rebuy.add', async () => {
        await refreshFoxCartDrawer({ open: true });
        const count = await getCartCount();
        updateHeaderCount(count);
      });